import {Article} from '../../Services/ArticleService';

export const SET_ARTICLE = 'articles/SET_ARTICLE';
export const CLEAR_ARTICLE = 'articles/CLEAR_ARTICLE';
export const SET_LOADING = 'articles/SET_LOADING';
export const SET_VOTE = 'articles/SET_VOTE';

interface SetArticleAction {
  type: typeof SET_ARTICLE;
  payload: Article;
}

interface ClearArticleAction {
  type: typeof CLEAR_ARTICLE;
}

interface SetLoadingAction {
  type: typeof SET_LOADING;
  payload: boolean;
}

interface SetVoteAction {
  type: typeof SET_VOTE;
  payload: {
    id: number;
    vote: boolean | undefined;
  }
}

export interface ArticlesState {
  article?: Article;
  loading: boolean;
  votes: Record<number, boolean | undefined>;
}

export type ArticlesActionTypes =
  SetArticleAction |
  ClearArticleAction |
  SetLoadingAction |
  SetVoteAction;
